// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xbHP","col":"styles_col__JtF3W"};